var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryCleaningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18373_68339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6898 2.03289C16.0398 1.76039 16.1023 1.25789 15.8298 0.910386C15.5573 0.562886 15.0548 0.497886 14.7073 0.770386L11.1073 3.57039L9.30727 4.97039L9.08977 5.14039L8.31977 4.15539C8.22727 4.03539 8.07477 3.98039 7.92477 4.01039C7.77477 4.04039 7.65727 4.15289 7.61727 4.29789L7.30477 5.45539L9.27727 7.97539L10.4773 7.95289C10.6298 7.95039 10.7648 7.86039 10.8298 7.72539C10.8948 7.59039 10.8773 7.42789 10.7848 7.30789L10.0748 6.39789L10.2898 6.23039L12.0898 4.83039L15.6898 2.03039V2.03289ZM0.417267 13.2929C1.35227 13.3629 5.33727 13.5929 6.72477 12.5079C8.16727 11.3804 8.64477 8.47039 8.64477 8.47039L6.67727 5.94789C6.67727 5.94789 3.73727 5.70789 2.29477 6.83539C1.72477 7.27789 1.26227 8.20289 0.907267 9.20039C0.847267 9.36789 1.02477 9.52039 1.18227 9.43539L2.15477 8.92539C2.25727 8.87039 2.38477 8.89789 2.45477 8.99039C2.52477 9.08289 2.52227 9.21039 2.44477 9.29789L0.609767 11.3604C0.329767 11.6729 0.137267 12.0529 0.059767 12.4629C0.037267 12.5829 0.019767 12.6854 0.00476701 12.7654C-0.017733 12.8904 0.017267 13.0179 0.094767 13.1179C0.172267 13.2179 0.287267 13.2829 0.414767 13.2929H0.417267Z",
    fill: "#707A83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18373_68339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12.8,
    fill: "white",
    transform: "translate(0 0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryCleaningIcon);
export default __webpack_public_path__ + "static/media/history-cleaning-icon.78f296ac90e5337cf381ed4665caae4e.svg";
export { ForwardRef as ReactComponent };